import { applyTheme, saveCachedTheme } from '@/theme'
import vuetify from '@/plugins/vuetify'

export default {
  namespaced: true,
  actions: {
    applyUserTheme(_, themeData) {
      if (themeData) {
        applyTheme(vuetify, themeData)
        saveCachedTheme(themeData)
      }
    },
  },
}
